import React, { useState } from "react";
import { useQuery } from "react-query";
import { wooProduct } from "../products/productInterface";
import { WooCommerce } from "../../../src/lib/api";
import {
  Link,
  useNavigate,
  useParams,
} from "react-router-dom";
import AddToCart from "../../../src/components/addToCart";
import {
  CopyCheck,
  ExternalLinkIcon,
  MinusIcon,
  PlusIcon,
  Share2,
} from "lucide-react";
import MyLoader from "../../../src/components/MyLoader";
import { toast } from "../../../src/components/ui/use-toast";
import { Breadcrumbs } from "../../../src/components/breadcrumbs";
import useWishlist from "../../../src/hooks/useWishlist";
import Wishlist from "../../components/Wishlist";
import HomeProducts from "../products/homeProducts";
import { ProductCarousel } from "../../components/productImageCarousel";
import { Button } from "../../../src/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../src/components/ui/accordion";
import ProductReview from "../../../src/components/productReview";
import { useCookies } from "react-cookie";
import ImageZoomWrapper from "../../../src/components/imageZoomWrapper";
import UpdateProductQuatity from "../cart/updateProductQuatity";
// type variation = Record<string, string>;
export default function Product() {
  const {
    categoryId,
    categoryName,
    productId,
    productName,
  } = useParams<{
    categoryId: string;
    categoryName: string;
    productId: string;
    productName: string;
  }>();
  const [quantity, setQuantity] = useState("1");
  const [mainImgSrc, setMainImgSrc] = useState("");
  const { data: wishlist } = useWishlist();
  const [cookies] = useCookies(["userToken"]);
  const wishlistArray = JSON.parse(
    window.localStorage.getItem("wishlistArray") as string
  );
  const { data: product, isLoading } = useQuery(
    ["singleProduct", productId],
    async () => {
      const res: wooProduct = WooCommerce.get(
        `products/${productId}`
      )
        .then((response: any) => {
          // setProductAttributes(response.data.attributes);

          response?.data?.images?.length > 0 &&
            setMainImgSrc(
              response.data.images[0].src || "/logo.png"
            );

          return response.data;
        })

        .catch((error: any) => {
          console.log("error getting product", error);
        });
      return res;
    }
  );

  const { data: productRating } = useQuery(
    ["productsRating"],
    async () => {
      const res = WooCommerce.get(`products/reviews/`)
        .then((response: any) => {
          return response.data;
        })
        .catch((error: any) => {
          console.log(error.response.data);
        });
      return res;
    }
  );
  interface ProductRating {
    product_id: number;
    rating: number;
  }

  const calculateProductRatingAverage = (
    productId: number,
    ratings: ProductRating[]
  ): number => {
    const productRatings = ratings
      ?.filter((rating) => rating.product_id === productId)
      .map((rating) => rating.rating);

    if (productRatings?.length === 0) {
      return 0;
    }

    const sum = productRatings.reduce(
      (acc, cur) => acc + cur,
      0
    );
    const average = sum / productRatings?.length;

    // Round to 1 decimal place
    return Number(average.toFixed(1));
  };
  const setImageOnClick = (src: string) => {
    setMainImgSrc(src);
  };
  const nav = useNavigate();
  return (
    <div className="sm:mt-32 mt-16 flex flex-col font-montserrat h-100 p-5">
      {isLoading ? (
        <div className="h-full w-full flex justify-center items-center">
          <MyLoader />
        </div>
      ) : (
        <div className="flex justify-between lg:gap-20 gap-5 items-center lg:pr-24 lg:pl-24 p-0 lg:flex-row flex-col">
          <div className="flex flex-col gap-2 justify-center items-center w-full">
            <div className="overflow-hidden w-full flex flex-col justify-center items-center ">
              <div className="border p-5 flex justify-center items-center dark:bg-white mb-5">
                <ImageZoomWrapper
                  src={mainImgSrc || "/logo.png"}
                  alt={product?.name || "product preview"}
                  className=""
                />
              </div>

              <ProductCarousel
                images={product?.images || []}
                setImageOnClick={setImageOnClick}
              />
            </div>
          </div>
          <div className="flex flex-col gap-5 w-full h-[600px] justify-start">
            <div className="flex gap-10 flex-col">
              <Breadcrumbs
                categoryName={
                  categoryName ||
                  product?.categories[2].name
                }
                categoryId={
                  categoryId ||
                  String(product?.categories[2].id)
                }
              />

              <div className="flex justify-between  gap-2">
                <h1 className="font-medium sm:text-xl text-md">
                  {product?.name?.toUpperCase()}
                </h1>
                <div className="flex justify-start gap-5 items-end mb-1">
                  <Wishlist
                    productId={product?.id || 0}
                    productName={product?.name || ""}
                    single
                    wishlist={
                      wishlist ? wishlist : wishlistArray
                    }
                  />
                  <Share2
                    onClick={() => {
                      navigator.clipboard.writeText(
                        window.location.href
                      );
                      toast({
                        title: "Link copied to clipboard",
                        action: <CopyCheck />,
                        className:
                          "fixed top-0 left-0 sm:relative",
                      });
                    }}
                    className="cursor-pointer w-5 hover:fill-neutral-900 dark:hover:fill-neutral-200"
                  />
                </div>
              </div>
            </div>

            <p className="font-bold text-xl">
              {product?.regular_price}.00$
            </p>

            <div className="flex items-center gap-2">
              <div className="border flex gap-1 justify-center items-center">
                <Button
                  variant="ghost"
                  className="rounded-none"
                  onClick={() =>
                    setQuantity(
                      Number(quantity) > 1
                        ? String(Number(quantity) - 1)
                        : "1"
                    )
                  }
                >
                  <MinusIcon className="w-4" />
                </Button>
                <p className="text-xl w-6 text-center">
                  {quantity}
                </p>

                <Button
                  variant="ghost"
                  className="rounded-none"
                  onClick={() =>
                    setQuantity(
                      String(Number(quantity) + 1)
                    )
                  }
                >
                  <PlusIcon className="w-4" />
                </Button>
              </div>
              {/* <UpdateProductQuatity
                productId={
                  String(product?.id || productId) || "1"
                }
                quantity={quantity}
              /> */}
            </div>
            {cookies.userToken && (
              <ProductReview
                rating={calculateProductRatingAverage(
                  Number(productId),
                  productRating
                )}
                productId={Number(productId)}
                viewOnly={false}
              />
            )}
            <div className="flex w-full sm:gap-10 gap-2 lg:flex-row flex-col">
              <AddToCart
                id={productId ? productId : "1"}
                quantity={quantity}
                categoryId={Number(categoryId)}
                categoryName={categoryName || ""}
                name={productName || ""}
              />
              <Button
                variant="outline"
                className="rounded-none sm:w-full"
                onClick={() =>
                  nav(
                    `/checkout/${productName}/${productId}/${product?.price}`
                  )
                }
              >
                BUY NOW
              </Button>
            </div>
            <Accordion
              type="single"
              collapsible
              className="w-full text-sm"
            >
              <AccordionItem value={"desc"}>
                <AccordionTrigger>
                  DESCRIPTION
                </AccordionTrigger>
                <AccordionContent>
                  {product?.description.slice(3, -5)}
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value={"details"}>
                <AccordionTrigger>DETAILS</AccordionTrigger>
                <AccordionContent>
                  {product?.short_description.slice(3, -5)}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
            <Link
              to="/terms-and-conditions"
              className="flex gap-1 justify-end items-start"
            >
              <p className="hover:underline cursor-pointer text-neutral-400 text-[12px]">
                Delivery & Terms
              </p>
              <ExternalLinkIcon className="h-3 w-3" />
            </Link>
          </div>
        </div>
      )}

      {product && (
        <div className="lg:p-24 mt-10 flex flex-col gap-20">
          <HomeProducts
            similar
            title="YOU MAY ALSO LIKE"
            categoryId={Number(
              categoryId || product?.categories[2].id
            )}
            productId={product.id}
          />
        </div>
      )}
    </div>
  );
}
